module.exports = __webpack_public_path__ + "static/media/mental-and-behavioral-disorders-icon.56df266e.svg";